const axios = require('axios');

export const postRequest = (action, config) => (dispatch) => {
  axios(config)
    .then(response => {
      dispatch({ type: action.success, payload: response.data })
    })
    .catch(error => {
      dispatch({ type: action.error, payload: error.response })
    })
}

export const saveData = (config, callback, initialCall) => {
  initialCall()
  axios(config)
    .then(function (response) {
      callback(response)
    })
    .catch(function (error) {
      callback(error);
    });
}

export const axiosPost = (config, callbackSucces, callbackFail) => {
  axios(config)
    .then(function (response) {
      if (callbackSucces) {
        callbackSucces(response)
      }
    })
    .catch(function (error) {
      if (callbackFail) {
        callbackFail(error)
      }
    });
}